import { Container, FormControlLabel, Grid, Radio } from "@mui/material";
import React, { useState } from "react";
import PreferOnboardImage from "../../../../styles/img/onboard/onboard-prefer.png";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { UiButton } from "../../component/common/UiButton";
import UiRadioInput from "../../component/common/UiRadioInput";
import { UiProgressbar } from "../../component/_uiComponents/UiProgressbar";
import { UiOptionBox } from "../../component/_uiComponents/UiOptionBox";
import Logo from "../../../../styles/img/df-logo.png";

export const UiRadioStepOne = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const backToHome = () => {
    navigate("/ui/login");
  };

  const handleOptionClick = (value) => {
    setSelectedOption(value);
  };

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container
          maxWidth="md"
          className="df-pos-rel df-onboard-progress-back-close"
        >
          <div
            className="df-user-profile__close-icon df-onboard-close-icon"
            onClick={backToHome}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <UiProgressbar />

            <BackIcon onClick={backToHome} />
          </div>

          <div className="df-user-profile__body df-pw-tab df-onboard-space-bottom">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <h2 className="df-reset-pw-title text-center">
                  Select your preferred option for registering
                </h2>

                <img
                  src={PreferOnboardImage}
                  className="df-reset-pw-img df-onboard-side-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2"
              >
                <div className="df-onboard-radio df-onboard-nic-wr">
                  <div className="df-options-container">
                    <UiOptionBox
                      label="Savings"
                      value="savings"
                      selected={selectedOption === "savings"}
                      onClick={handleOptionClick}
                    />
                    <UiOptionBox
                      label="Fixed Deposits"
                      value="fixed-deposits"
                      selected={selectedOption === "fixed-deposits"}
                      onClick={handleOptionClick}
                    />
                    <UiOptionBox
                      label="Lending"
                      value="lending"
                      selected={selectedOption === "lending"}
                      onClick={handleOptionClick}
                    />
                    <UiOptionBox
                      label="Pawning"
                      value="pawning"
                      selected={selectedOption === "pawning"}
                      onClick={handleOptionClick}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
